var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 45.5C10.5736 45.5 0.499999 35.4264 0.5 23C0.500001 10.5736 10.5736 0.499999 23 0.5C35.4264 0.500001 45.5 10.5736 45.5 23C45.5 35.4264 35.4264 45.5 23 45.5Z",
    fill: "#FFDB44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0834 15.125C40.8912 6.5825 32.6559 0.5 23 0.5C13.3441 0.5 5.10878 6.5825 1.91662 15.125L44.0834 15.125Z",
    fill: "#D90026"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91662 30.875C5.10877 39.4175 13.3441 45.5 23 45.5C32.6559 45.5 40.8912 39.4175 44.0834 30.875L1.91662 30.875Z",
    fill: "#D90026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/spanish.b8aaa8197a72c0e41ad2bc641cc8d88b.svg";
export { ForwardRef as ReactComponent };